import { IoIosSearch } from 'react-icons/io';
import {
  CardCarInformation,
  DefaultDivCard,
  DefaultTextCard,
  RowPlateDetran,
  SpanPlateDetran,
} from './style';
import { FaCarSide } from 'react-icons/fa';

interface IProps {
  plate?: string;
  uf?: string;
  year?: string;
  brand?: string;
}

const StyledCardInformationCar = ({
  plate = '--',
  uf = '--',
  year = '--',
  brand = '--',
}: IProps) => (
  <CardCarInformation>
    <RowPlateDetran>
      <SpanPlateDetran>
        <FaCarSide
          style={{
            display: 'inline-block',
            verticalAlign: 'middle',
            marginRight: '8px',
            fontSize: '30px',
          }}
        />
        Placa: {plate}
      </SpanPlateDetran>
      <SpanPlateDetran>
        <IoIosSearch
          style={{
            display: 'inline-block',
            verticalAlign: 'middle',
            marginRight: '4px',
            fontSize: '30px',
          }}
        />
        DETRAN {uf}
      </SpanPlateDetran>
    </RowPlateDetran>

    <div className="row">
      <DefaultDivCard>
        <DefaultTextCard color="rgba(97, 97, 97, 1)" weight={600}>
          Ano:
        </DefaultTextCard>
        <DefaultTextCard color="rgba(128, 126, 128, 1)" weight={400}>
          &nbsp;{year}
        </DefaultTextCard>
      </DefaultDivCard>
      <DefaultDivCard>
        <DefaultTextCard color="rgba(97, 97, 97, 1)" weight={600}>
          Marca:
        </DefaultTextCard>
        <DefaultTextCard color="rgba(128, 126, 128, 1)" weight={400}>
          &nbsp;{brand}
        </DefaultTextCard>
      </DefaultDivCard>
    </div>
  </CardCarInformation>
);

export { StyledCardInformationCar };
